mutation BookLandingpage($input: BookLandingpageInput!) {
  bookLandingpage(input: $input)
}
